type TJobVersion = {
  metrics?: { editsCount: number } | null;
};

export function canChooseCloudLayout(status?: string | null, versions?: TJobVersion[] | null): boolean {
  if (status !== 'JOB_STATUS_READY_FOR_TRANSCRIBING') {
    return false;
  }

  return (versions ?? []).every((version) => (version.metrics?.editsCount ?? 0) === 0);
}
